<template>
    <div class="flex padding flex-h-center" style="width:100vw;">
        <div>
            <el-tabs style="margin: 0 40px;" v-model="pteMode">
                <el-tab-pane label="PTE Core" name="ptec"></el-tab-pane>
                <el-tab-pane label="PTE Academic / UKVI" name="ptea"></el-tab-pane>
            </el-tabs>
            <div class="flex padding flex-h-center">
                <div v-for="(sort, index) in $store.getters.getSorts()" class="margin-x" :key="index">
                    <h3 style="margin-left:6px;">{{ sort.title }}</h3>
                    <div v-for="(type, index1) in sort.types" class="mt1 margin-ts pointer ul-hover" :key="index1"
                        @click="to('/main/pte?tag=' + type.tag, 'PTE')">{{ type.title }}
                        <core-label :type="type"></core-label>
                        <span class="st" style="font-size: 11px;" v-if="type.ai_flag">
                            {{ $t('AI评分') }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="margin-x">
            <h4 style="margin-left:6px; margin-top: 73px;">More</h4>
            <div @click="walkman()" class="mt1 margin-ts pointer ul-hover">{{ $t('PTE随身听') }}</div>
            <div @click="to('/main/download', 'PTE')" class="mt1 margin-ts pointer ul-hover">{{ $t('题库一键导出 PDF') }}
            </div>
            <div @click="to('/main/wordbook', 'PTE')" class="mt1 margin-ts pointer ul-hover">{{ $t('PTE词库') }}
            </div>
            <!-- <div @click="to('/main/favorites','PTE')" class="mt1 margin-ts pointer ul-hover">{{$t('我的收藏')}} </div> -->
            <div @click="to('/main/mocks', 'PTE')" class="mt1 margin-ts pointer ul-hover">{{ $t('PTE模考') }} <span v-if="pteMode == 'ptec'" class="color-primary">(Core)</span><span class="st" style="font-size: 11px;">
                            {{ $t('AI评分') }}</span></div>

        </div>
    </div>
</template>

<script>
import coreLabel from './CoreLabel.vue';

export default {

    components: { coreLabel },
    computed: {
        pteMode: {
            get() {
                return this.$store.state.pteMode
            },
            set(val) {
                this.$store.commit('set_pte_mode', val)
            }
        },
    },
    methods: {
        to(url, mode) {
            this.$store.commit("setMode", mode);
            this.$router.push(url);
        },

        walkman() {
            window.open("https://www.ptefighter.com/walkman")
        },
    }
}
</script>
